/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.0
 * @since 1.25.0
 */
import { apiTags } from '@/main/api/page.api';

export function invalidateOnSuccess(error: unknown, tags: typeof apiTags) {
    if (error) return [];
    return tags;
}
